import { gettext, modals, user } from '@bikemap/js/services'
import { logError } from '@bikemap/js/utility'

/**
 * Initialize functionality of content report buttons that trigger a pre-filled email.
 */
export function initReportLinks() {
    document.querySelectorAll('.js-init-report-link').forEach((link) => {
        const { entityType, entityId } = link.dataset
        if (entityType && entityId) {
            link.addEventListener('click', e => {
                e.preventDefault()
                showReportModal(entityType, entityId)
            })
        } else {
            logError('Insufficient report button properties.')
        }
    })
}

async function showReportModal(entityType, entityId) {
    const userEntity = await user.getEntity()
    const subject = 'Report for ' + entityType
    const entityUrl = location.href
    const text = 'Dear Bikemap team,%0D%0A%0D%0AI would like to report ' + entityType + ' ' + entityId + ' (' + entityUrl +
        ") as I think it violates the platform's Terms of Service.%0D%0A%0D%0ASincerely yours,%0D%0A" +
        ((userEntity && userEntity.name) || '<name>') + '%0D%0A___________%0D%0AUser: ' + ((userEntity && userEntity.id) || 'Anonymous')
    const href = 'mailto:support@bikemap.net?subject=' + subject + '&body=' + text

    modals.show('content-report', {
        title: gettext('Are you sure you want to report this content?'),
        message: gettext('Your report will be reviewed by our team to ensure it complies with our community guidelines. Please make sure to include some context to your report to help us better understand the situation.'),
        buttons: [
            { content: gettext('Write a Report'), style: 'danger', href },
        ],
    })
}
